import { render, staticRenderFns } from "./quotationToolsCost-tab.vue?vue&type=template&id=b2950b14"
import script from "./quotationToolsCost-tab.vue?vue&type=script&lang=js"
export * from "./quotationToolsCost-tab.vue?vue&type=script&lang=js"
import style0 from "./quotationToolsCost-tab.vue?vue&type=style&index=0&id=b2950b14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports